(function () {
  'use strict';

  var STORAGE_KEY = 'vexRecentlyViewed';
  var MAX_STORED = 12;
  var DESKTOP_BP = 769;
  var RV_ITEM_SECTION = 'rv-product-card';
  var splideInstances = new WeakMap();
  var resizeTimer = null;
  var judgeMeListenerBound = false;

  var RV_CONFIG = {
    sectionClass: 'vex-rv',
    visibleClass: 'vex-rv--visible',
    gridSelector: '[data-vex-rv-grid]',
    sliderSelector: '[data-vex-rv-slider]',
    gridBaseClass: 'vex-rv__grid products-section__grid products-grid',
    gridCountClass: 'vex-rv__grid--count-',
  };

  var CAB_CONFIG = {
    sectionClass: 'vex-cab',
    visibleClass: 'vex-cab--visible',
    gridSelector: '[data-vex-cab-grid]',
    sliderSelector: '[data-vex-cab-slider]',
    gridBaseClass: 'vex-cab__grid products-section__grid products-grid',
    gridCountClass: 'vex-cab__grid--count-',
  };

  function initVexCollectionList(root) {
    if (!root || root.dataset.vexClInit === 'true') {
      return;
    }

    root.dataset.vexClInit = 'true';
  }

  function moveCartHeader(itemsSection, headerSlot) {
    if (!itemsSection || !headerSlot) {
      return;
    }

    var header = itemsSection.querySelector('.vex-cart__header');

    if (header && !headerSlot.contains(header)) {
      headerSlot.appendChild(header);
    }

    headerSlot.hidden = !!itemsSection.querySelector('cart-items.is-empty');
  }

  function ensureCartHeaderSlot(shell) {
    var headerSlot = document.querySelector('[data-vex-cart-header]');

    if (!headerSlot && shell) {
      headerSlot = document.createElement('div');
      headerSlot.className = 'vex-cart__header-slot';
      headerSlot.setAttribute('data-vex-cart-header', '');

      var gridEl = shell.querySelector('.vex-cart__grid');

      if (gridEl) {
        shell.insertBefore(headerSlot, gridEl);
      } else {
        shell.appendChild(headerSlot);
      }
    }

    return headerSlot;
  }

  function normalizeShellOrder(shell) {
    if (!shell) {
      return;
    }

    var progressSlot = shell.querySelector('[data-vex-cart-progress]');
    var headerSlot = shell.querySelector('[data-vex-cart-header]');
    var grid = shell.querySelector('.vex-cart__grid');

    if (!grid) {
      return;
    }

    if (progressSlot) {
      shell.insertBefore(progressSlot, grid);
    }

    if (headerSlot) {
      shell.insertBefore(headerSlot, grid);
    }
  }

  function moveCartProgressBar(itemsSection, progressSlot) {
    if (!itemsSection || !progressSlot) {
      return;
    }

    var container = itemsSection.querySelector('.vex-cart__container');

    if (container) {
      Array.prototype.slice.call(container.children).forEach(function (child) {
        if (
          child.classList.contains('vex-cart__header') ||
          child.classList.contains('cart__warnings') ||
          child.id === 'cart'
        ) {
          return;
        }

        progressSlot.appendChild(child);
      });
    }

    var selectors = [
      '[id^="ss-fsbar-"]:not(template)',
      '[class*="ss-fsbar-section"]',
      '[class*="free-shipping"]',
      '[class*="shipping-bar"]',
      '[class*="shipping-progress"]',
      '[class*="efs-"]',
      '[data-essential-shipping]',
      '[class*="essential"]',
      '[id*="essential"]',
    ];

    selectors.forEach(function (selector) {
      itemsSection.querySelectorAll(selector).forEach(function (node) {
        if (
          node.tagName === 'TEMPLATE' ||
          progressSlot.contains(node) ||
          node.closest('.cart__warnings') ||
          node.closest('form#cart')
        ) {
          return;
        }

        progressSlot.appendChild(node);
      });
    });

    var shell = progressSlot.parentElement;

    if (shell) {
      var sibling = shell.previousElementSibling;

      while (sibling) {
        var isShippingSection =
          sibling.classList.contains('ss-free-shipping-bar') ||
          sibling.querySelector('[id^="ss-fsbar-"]') ||
          sibling.querySelector('[class*="ss-fsbar-section"]');

        if (sibling.classList.contains('shopify-section') && isShippingSection) {
          progressSlot.appendChild(sibling);
          break;
        }

        sibling = sibling.previousElementSibling;
      }
    }
  }

  function initVexCartLayout() {
    if (!document.body.classList.contains('template-cart')) {
      return;
    }

    var itemsSection = null;
    var footerSection = document.querySelector('.shopify-section.cart__footer-wrapper');
    var sections = document.querySelectorAll('.shopify-section');

    sections.forEach(function (section) {
      if (section.querySelector('cart-items')) {
        itemsSection = section;
      }
    });

    if (!itemsSection || !footerSection || !itemsSection.parentNode) {
      return;
    }

    var shell = document.querySelector('.vex-cart__shell');
    var grid = document.querySelector('.vex-cart__grid');
    var progressSlot = document.querySelector('.vex-cart__progress');

    if (!shell && grid) {
      shell = document.createElement('div');
      shell.className = 'vex-cart__shell';
      progressSlot = document.createElement('div');
      progressSlot.className = 'vex-cart__progress';
      progressSlot.setAttribute('data-vex-cart-progress', '');
      grid.parentNode.insertBefore(shell, grid);
      shell.appendChild(progressSlot);
      shell.appendChild(grid);
      ensureCartHeaderSlot(shell);
    } else if (!shell) {
      shell = document.createElement('div');
      shell.className = 'vex-cart__shell';

      progressSlot = document.createElement('div');
      progressSlot.className = 'vex-cart__progress';
      progressSlot.setAttribute('data-vex-cart-progress', '');

      grid = document.createElement('div');
      grid.className = 'vex-cart__grid';

      itemsSection.parentNode.insertBefore(shell, itemsSection);
      shell.appendChild(progressSlot);
      shell.appendChild(grid);
      grid.appendChild(itemsSection);
      grid.appendChild(footerSection);
      ensureCartHeaderSlot(shell);
    } else {
      ensureCartHeaderSlot(shell);
    }

    var headerSlot = document.querySelector('[data-vex-cart-header]');

    moveCartProgressBar(itemsSection, progressSlot);
    moveCartHeader(itemsSection, headerSlot);
    normalizeShellOrder(shell);

    if (!window._vexCartProgressObserver) {
      window._vexCartProgressObserver = new MutationObserver(function () {
        var liveItemsSection = null;
        var liveSections = document.querySelectorAll('.shopify-section');

        liveSections.forEach(function (section) {
          if (section.querySelector('cart-items')) {
            liveItemsSection = section;
          }
        });

        var liveShell = document.querySelector('.vex-cart__shell');
        var liveProgressSlot = document.querySelector('[data-vex-cart-progress]');
        var liveHeaderSlot = document.querySelector('[data-vex-cart-header]');
        moveCartProgressBar(liveItemsSection, liveProgressSlot);
        moveCartHeader(liveItemsSection, liveHeaderSlot);
        normalizeShellOrder(liveShell);
      });

      if (itemsSection) {
        window._vexCartProgressObserver.observe(itemsSection, {
          childList: true,
          subtree: true,
        });
      }
    }

    if (!window._vexCartRelayoutDone) {
      window._vexCartRelayoutDone = true;

      window.setTimeout(function () {
        moveCartProgressBar(itemsSection, document.querySelector('[data-vex-cart-progress]'));
        moveCartHeader(itemsSection, document.querySelector('[data-vex-cart-header]'));
        normalizeShellOrder(document.querySelector('.vex-cart__shell'));
      }, 800);

      window.setTimeout(function () {
        moveCartProgressBar(itemsSection, document.querySelector('[data-vex-cart-progress]'));
        normalizeShellOrder(document.querySelector('.vex-cart__shell'));
      }, 2500);
    }
  }

  function trackProductView(handle) {
    if (!handle) {
      return;
    }

    try {
      var viewed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      viewed = viewed.filter(function (item) {
        return item !== handle;
      });
      viewed.unshift(handle);
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(viewed.slice(0, MAX_STORED))
      );
    } catch (error) {
      /* ignore storage errors */
    }
  }

  function getViewedHandles(excludeHandle) {
    try {
      var viewed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

      if (excludeHandle) {
        viewed = viewed.filter(function (item) {
          return item !== excludeHandle;
        });
      }

      return viewed;
    } catch (error) {
      return [];
    }
  }

  function extractCardHtml(sectionHtml) {
    var temp = document.createElement('div');
    temp.innerHTML = sectionHtml;
    var card = temp.querySelector('.products-item');

    return card ? card.outerHTML : sectionHtml;
  }

  function extractProductCards(container) {
    if (!container) {
      return [];
    }

    return Array.prototype.map.call(
      container.querySelectorAll('.products-item'),
      function (card) {
        return card.outerHTML;
      }
    );
  }

  function fetchProductCardHtml(handle) {
    var url =
      '/products/' +
      encodeURIComponent(handle) +
      '?sections=' +
      RV_ITEM_SECTION;

    return fetch(url)
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data || !data[RV_ITEM_SECTION]) {
          return null;
        }

        var cardHtml = extractCardHtml(data[RV_ITEM_SECTION]);

        if (!cardHtml || cardHtml.indexOf('products-item') === -1) {
          return null;
        }

        return {
          handle: handle,
          html: cardHtml,
        };
      })
      .catch(function () {
        return null;
      });
  }

  function fetchProductCardsInOrder(handles) {
    return Promise.all(handles.map(fetchProductCardHtml)).then(function (results) {
      return results
        .filter(Boolean)
        .sort(function (a, b) {
          return handles.indexOf(a.handle) - handles.indexOf(b.handle);
        });
    });
  }

  function isMobile() {
    return window.innerWidth < DESKTOP_BP;
  }

  function getSectionEl(root, config) {
    return root.closest('section.' + config.sectionClass);
  }

  function hideCarouselSection(root, config) {
    var sectionEl = getSectionEl(root, config);
    if (sectionEl) {
      sectionEl.classList.remove(config.visibleClass);
    }
  }

  function showCarouselSection(root, config) {
    var sectionEl = getSectionEl(root, config);
    if (sectionEl) {
      sectionEl.classList.add(config.visibleClass);
    }
  }

  function destroySplide(sliderEl) {
    var instance = splideInstances.get(sliderEl);
    if (instance) {
      instance.destroy();
      splideInstances.delete(sliderEl);
    }
  }

  function refreshJudgeMe(scope) {
    var context = scope || document;

    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
      return;
    }

    if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') {
      window.jdgm.loadWidgets();
    }

    if (
      window.jdgm &&
      window.jdgm.widget &&
      typeof window.jdgm.widget.loadWidgets === 'function'
    ) {
      window.jdgm.widget.loadWidgets(context);
    }
  }

  function scheduleJudgeMeRefresh(scope) {
    refreshJudgeMe(scope);
    setTimeout(function () {
      refreshJudgeMe(scope);
    }, 500);
    setTimeout(function () {
      refreshJudgeMe(scope);
    }, 1500);
  }

  function bindJudgeMeListeners() {
    if (judgeMeListenerBound) {
      return;
    }

    judgeMeListenerBound = true;

    document.addEventListener('jdgm.doneSettingUp', function () {
      document.querySelectorAll('[data-vex-rv], [data-vex-cab]').forEach(function (root) {
        scheduleJudgeMeRefresh(root);
      });
    });

    document.addEventListener('jdgm.doneLoadingWidgets', function () {
      document.querySelectorAll('[data-vex-rv], [data-vex-cab]').forEach(function (root) {
        scheduleJudgeMeRefresh(root);
      });
    });
  }

  function initSplide(sliderEl, listEl, slidesHtml) {
    if (typeof Splide === 'undefined') {
      return;
    }

    destroySplide(sliderEl);
    listEl.innerHTML = slidesHtml;

    var splide = new Splide(sliderEl, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '43px',
      arrows: true,
      pagination: false,
      autoHeight: true,
      breakpoints: {
        1024: { perPage: 3 },
        768: { perPage: 2 },
        580: { perPage: 2 },
      },
    });

    splide.on('mounted', function () {
      scheduleJudgeMeRefresh(sliderEl);
    });

    splide.on('moved', function () {
      scheduleJudgeMeRefresh(sliderEl);
    });

    splide.on('updated', function () {
      scheduleJudgeMeRefresh(sliderEl);
    });

    splide.mount();
    splideInstances.set(sliderEl, splide);
    scheduleJudgeMeRefresh(sliderEl);
  }

  function applyCarouselLayout(root, cardHtmlList, config) {
    var gridEl = root.querySelector(config.gridSelector);
    var sliderEl = root.querySelector(config.sliderSelector);
    var sliderListEl = sliderEl ? sliderEl.querySelector('.splide__list') : null;
    var count = cardHtmlList.length;

    if (!count) {
      hideCarouselSection(root, config);
      return;
    }

    var slideHtml = cardHtmlList
      .map(function (card) {
        return '<div class="splide__slide">' + card + '</div>';
      })
      .join('');
    var useSlider = isMobile() || count > 4;

    if (useSlider) {
      if (gridEl) {
        gridEl.hidden = true;
        gridEl.innerHTML = '';
        gridEl.className = config.gridBaseClass;
      }

      if (sliderEl && sliderListEl) {
        sliderEl.hidden = false;

        if (typeof Splide === 'undefined') {
          sliderEl.hidden = true;
          if (gridEl) {
            gridEl.hidden = false;
            gridEl.innerHTML = cardHtmlList.join('');
            gridEl.className = config.gridBaseClass;
          }
          scheduleJudgeMeRefresh(gridEl || root);
        } else {
          initSplide(sliderEl, sliderListEl, slideHtml);
        }
      }
    } else {
      if (sliderEl) {
        sliderEl.hidden = true;
        destroySplide(sliderEl);
        if (sliderListEl) {
          sliderListEl.innerHTML = '';
        }
      }

      if (gridEl) {
        gridEl.hidden = false;
        gridEl.innerHTML = cardHtmlList.join('');
        gridEl.className = config.gridBaseClass + ' ' + config.gridCountClass + count;
      }

      scheduleJudgeMeRefresh(gridEl || root);
    }

    showCarouselSection(root, config);
  }

  function getFallbackCards(root, excludeProductId) {
    var fallbackEl = root.querySelector('[data-vex-cab-fallback]');
    return filterExcludedCards(extractProductCards(fallbackEl), excludeProductId);
  }

  function getProductIdFromCardHtml(html) {
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var card = temp.querySelector('[data-product-id]');
    var badge = temp.querySelector('.jdgm-preview-badge');

    if (card && card.dataset.productId) {
      return card.dataset.productId;
    }

    if (badge && badge.dataset.id) {
      return badge.dataset.id;
    }

    return null;
  }

  function filterExcludedCards(cards, excludeProductId) {
    if (!excludeProductId) {
      return cards;
    }

    return cards.filter(function (html) {
      var productId = getProductIdFromCardHtml(html);
      return !productId || String(productId) !== String(excludeProductId);
    });
  }

  function parseRecommendationHtml(html, sectionId) {
    if (!html) {
      return [];
    }

    var fragment = '';

    try {
      var json = JSON.parse(html);
      if (json && typeof json === 'object') {
        fragment = json[sectionId] || Object.values(json)[0] || '';
      }
    } catch (error) {
      fragment = html;
    }

    var temp = document.createElement('div');
    temp.innerHTML = fragment;

    var productsEl = temp.querySelector('[data-vex-cab-products]');
    var cards = extractProductCards(productsEl);

    if (cards.length) {
      return cards;
    }

    return extractProductCards(temp);
  }

  function fetchRecommendationCardsForIntent(root, intent) {
    var url = root.dataset.recommendationsUrl;
    var sectionId = root.dataset.sectionId;
    var productId = root.dataset.productId;
    var limit = root.dataset.limit || '8';

    if (!url || !sectionId || !productId) {
      return Promise.resolve([]);
    }

    var fetchUrl =
      url +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(limit) +
      '&intent=' +
      encodeURIComponent(intent);

    return fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) {
          return '';
        }

        return response.text();
      })
      .then(function (html) {
        return parseRecommendationHtml(html, sectionId);
      })
      .catch(function () {
        return [];
      });
  }

  function fetchRecommendationCards(root) {
    var excludeProductId = root.dataset.excludeProductId;

    return fetchRecommendationCardsForIntent(root, 'complementary').then(function (cards) {
      if (cards.length) {
        return filterExcludedCards(cards, excludeProductId);
      }

      return fetchRecommendationCardsForIntent(root, 'related').then(function (relatedCards) {
        return filterExcludedCards(relatedCards, excludeProductId);
      });
    });
  }

  function initRecentlyViewed(root) {
    if (!root) {
      return;
    }

    var currentHandle = root.dataset.currentHandle || '';

    if (currentHandle) {
      trackProductView(currentHandle);
    }

    var handles = getViewedHandles(currentHandle);

    if (!handles.length) {
      hideCarouselSection(root, RV_CONFIG);
      root.dataset.vexRvInit = 'true';
      root._vexRvCards = [];
      return;
    }

    fetchProductCardsInOrder(handles).then(function (cards) {
      var cardHtmlList = cards.map(function (card) {
        return card.html;
      });
      root._vexRvCards = cardHtmlList;
      applyCarouselLayout(root, cardHtmlList, RV_CONFIG);
      root.dataset.vexRvInit = 'true';
    });
  }

  function refreshRecentlyViewed(root) {
    if (!root || !root._vexRvCards) {
      initRecentlyViewed(root);
      return;
    }

    applyCarouselLayout(root, root._vexRvCards, RV_CONFIG);
  }

  function initCustomersAlsoBought(root) {
    if (!root) {
      return;
    }

    var productId = root.dataset.productId;
    var excludeProductId = root.dataset.excludeProductId;
    var fallbackCards = getFallbackCards(root, excludeProductId);

    if (!productId) {
      if (fallbackCards.length) {
        root._vexCabCards = fallbackCards;
        applyCarouselLayout(root, fallbackCards, CAB_CONFIG);
      } else {
        hideCarouselSection(root, CAB_CONFIG);
        root._vexCabCards = [];
      }

      root.dataset.vexCabInit = 'true';
      return;
    }

    if (fallbackCards.length) {
      root._vexCabCards = fallbackCards;
      applyCarouselLayout(root, fallbackCards, CAB_CONFIG);
    }

    fetchRecommendationCards(root).then(function (cards) {
      if (!cards.length) {
        cards = getFallbackCards(root, excludeProductId);
      }

      root._vexCabCards = cards;
      applyCarouselLayout(root, cards, CAB_CONFIG);
      root.dataset.vexCabInit = 'true';
    });
  }

  function refreshCustomersAlsoBought(root) {
    if (!root || !root._vexCabCards) {
      initCustomersAlsoBought(root);
      return;
    }

    applyCarouselLayout(root, root._vexCabCards, CAB_CONFIG);
  }

  var drawerCabSectionIdPromise = null;

  function resolveDrawerCabSectionId() {
    if (window._vexDrawerCabSectionId) {
      return Promise.resolve(window._vexDrawerCabSectionId);
    }

    if (drawerCabSectionIdPromise) {
      return drawerCabSectionIdPromise;
    }

    drawerCabSectionIdPromise = fetch('/cart?sections=customers-also-bought')
      .then(function (response) {
        return response.ok ? response.json() : {};
      })
      .then(function (data) {
        var html = data['customers-also-bought'] || '';
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var cabRoot = temp.querySelector('[data-vex-cab]');
        window._vexDrawerCabSectionId = cabRoot
          ? cabRoot.dataset.sectionId
          : 'customers-also-bought';
        return window._vexDrawerCabSectionId;
      })
      .catch(function () {
        window._vexDrawerCabSectionId = 'customers-also-bought';
        return window._vexDrawerCabSectionId;
      });

    return drawerCabSectionIdPromise;
  }

  function getHandleFromCardHtml(html) {
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var link = temp.querySelector('a[href*="/products/"]');

    if (!link) {
      return null;
    }

    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function fetchDrawerCabFallbackCards() {
    return fetch('/cart?sections=customers-also-bought')
      .then(function (response) {
        return response.ok ? response.json() : {};
      })
      .then(function (data) {
        var html = data['customers-also-bought'] || '';
        var temp = document.createElement('div');
        temp.innerHTML = html;
        return extractProductCards(temp.querySelector('[data-vex-cab-fallback]'));
      })
      .catch(function () {
        return [];
      });
  }

  function fetchDrawerRecommendationCards(root, sectionId) {
    var url = root.dataset.recommendationsUrl;
    var productId = root.dataset.productId;
    var limit = root.dataset.limit || '8';

    if (!url || !sectionId || !productId) {
      return Promise.resolve([]);
    }

    function fetchIntent(intent) {
      var fetchUrl =
        url +
        '?section_id=' +
        encodeURIComponent(sectionId) +
        '&product_id=' +
        encodeURIComponent(productId) +
        '&limit=' +
        encodeURIComponent(limit) +
        '&intent=' +
        encodeURIComponent(intent);

      return fetch(fetchUrl)
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          return parseRecommendationHtml(html, sectionId);
        })
        .catch(function () {
          return [];
        });
    }

    return fetchIntent('complementary').then(function (cards) {
      if (cards.length) {
        return cards;
      }

      return fetchIntent('related');
    });
  }

  function formatDrawerMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getDrawerCartProductIds() {
    var ids = [];
    var drawer = document.querySelector('cart-drawer');

    if (!drawer) {
      return ids;
    }

    drawer.querySelectorAll('.cart-item[data-product-id]').forEach(function (row) {
      if (row.dataset.productId) {
        ids.push(String(row.dataset.productId));
      }
    });

    return ids;
  }

  function formatVariantLabel(title) {
    if (!title) {
      return '';
    }

    return title
      .toLowerCase()
      .replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
  }

  function buildDrawerCabCardHtml(product) {
    var imageSrc = product.featured_image || '';
    var variants = product.variants || [];
    var availableVariants = variants.filter(function (variant) {
      return variant.available;
    });

    if (!availableVariants.length) {
      return '';
    }

    var defaultVariant = availableVariants[0];
    var hasMultipleVariants = availableVariants.length > 1;
    var optionsHtml = '';

    if (hasMultipleVariants) {
      optionsHtml =
        '<select class="vex-drawer-cab-card__select" data-vex-drawer-cab-variant aria-label="Select variant">';
      availableVariants.forEach(function (variant) {
        optionsHtml +=
          '<option value="' +
          variant.id +
          '" data-price="' +
          variant.price +
          '">' +
          formatVariantLabel(variant.title) +
          '</option>';
      });
      optionsHtml += '</select>';
    } else {
      optionsHtml =
        '<input type="hidden" data-vex-drawer-cab-variant value="' +
        defaultVariant.id +
        '">';
    }

    return (
      '<div class="vex-drawer-cab-card" data-product-id="' +
      product.id +
      '">' +
      '<div class="vex-drawer-cab-card__image">' +
      (imageSrc
        ? '<img src="' + imageSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="64" height="64">'
        : '') +
      '</div>' +
      '<div class="vex-drawer-cab-card__info">' +
      '<p class="vex-drawer-cab-card__title">' +
      product.title +
      '</p>' +
      '<p class="vex-drawer-cab-card__price" data-vex-drawer-cab-price>' +
      formatDrawerMoney(defaultVariant.price) +
      '</p>' +
      optionsHtml +
      '</div>' +
      '<button type="button" class="vex-drawer-cab-card__add button" data-vex-drawer-cab-add>Add</button>' +
      '</div>'
    );
  }

  function fetchDrawerProductByHandle(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function bindDrawerCabCardEvents(root) {
    root.querySelectorAll('.vex-drawer-cab-card').forEach(function (card) {
      if (card.dataset.vexDrawerCabBound === 'true') {
        return;
      }

      card.dataset.vexDrawerCabBound = 'true';

      var select = card.querySelector('[data-vex-drawer-cab-variant]');
      var priceEl = card.querySelector('[data-vex-drawer-cab-price]');
      var addBtn = card.querySelector('[data-vex-drawer-cab-add]');

      if (select && select.tagName === 'SELECT' && priceEl) {
        select.addEventListener('change', function () {
          var option = select.options[select.selectedIndex];
          if (option && option.dataset.price) {
            priceEl.textContent = formatDrawerMoney(parseInt(option.dataset.price, 10));
          }
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (addBtn.classList.contains('loading') || addBtn.getAttribute('aria-disabled') === 'true') {
            return;
          }

          var variantInput = card.querySelector('[data-vex-drawer-cab-variant]');
          var variantId = variantInput ? variantInput.value : null;

          if (!variantId) {
            return;
          }

          addDrawerCabToCart(variantId, addBtn);
        });
      }
    });
  }

  function getDrawerSectionHtml(sections) {
    if (!sections) {
      return '';
    }

    if (sections['cart-drawer']) {
      return sections['cart-drawer'];
    }

    var sectionKey = Object.keys(sections).find(function (key) {
      return key.indexOf('cart-drawer') !== -1;
    });

    return sectionKey ? sections[sectionKey] : '';
  }

  function syncDrawerEmptyState(cartDrawer, parsed) {
    var cabRoot = cartDrawer.querySelector('[data-vex-drawer-cab]');

    if (cabRoot) {
      var sliderEl = cabRoot.querySelector('[data-vex-drawer-cab-slider]');

      if (sliderEl) {
        destroySplide(sliderEl);
      }
    }

    var cabRow = cartDrawer.querySelector('.vex-drawer-cab-row');

    if (cabRow) {
      cabRow.remove();
    }

    var wrapper = cartDrawer.querySelector('.drawer__cart-items-wrapper');

    if (wrapper) {
      wrapper.remove();
    }

    var footer = cartDrawer.querySelector('.vex-drawer__footer');

    if (footer) {
      footer.remove();
    }

    var inner = cartDrawer.querySelector('.drawer__inner');
    var emptySource = parsed.querySelector('.drawer__inner-empty');

    if (inner && emptySource && !cartDrawer.querySelector('.drawer__inner-empty')) {
      inner.insertBefore(emptySource.cloneNode(true), inner.firstChild);
    }

    cartDrawer.classList.add('is-empty');

    var itemsEl = cartDrawer.querySelector('cart-drawer-items');

    if (itemsEl) {
      itemsEl.classList.add('is-empty');
    }
  }

  function syncDrawerFilledState(cartDrawer, parsed) {
    var emptyEl = cartDrawer.querySelector('.drawer__inner-empty');

    if (emptyEl) {
      emptyEl.remove();
    }

    var itemsEl = cartDrawer.querySelector('cart-drawer-items');

    if (itemsEl) {
      itemsEl.classList.remove('is-empty');
    }

    cartDrawer.classList.remove('is-empty');

    var wrapper = cartDrawer.querySelector('.drawer__cart-items-wrapper');
    var newWrapper = parsed.querySelector('.drawer__cart-items-wrapper');

    if (!wrapper && newWrapper) {
      var contents = cartDrawer.querySelector('#CartDrawer-CartItems');
      var liveRegion = contents ? contents.querySelector('#CartDrawer-LiveRegionText') : null;
      var lineStatus = contents ? contents.querySelector('#CartDrawer-LineItemStatus') : null;
      var importedWrapper = newWrapper.cloneNode(true);

      if (contents) {
        if (liveRegion) {
          contents.insertBefore(importedWrapper, liveRegion);
        } else if (lineStatus) {
          contents.insertBefore(importedWrapper, lineStatus);
        } else {
          contents.appendChild(importedWrapper);
        }
      }
    }

    var footerTarget = cartDrawer.querySelector('.vex-drawer__footer');
    var newFooter = parsed.querySelector('.vex-drawer__footer');

    if (newFooter) {
      if (footerTarget) {
        footerTarget.innerHTML = newFooter.innerHTML;
      } else {
        var form = cartDrawer.querySelector('#CartDrawer-Form');

        if (form) {
          form.appendChild(newFooter.cloneNode(true));
        }
      }
    }
  }

  function syncDrawerCartItems(sections) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionHtml = getDrawerSectionHtml(sections);

    if (!cartDrawer || !sectionHtml) {
      return;
    }

    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var newTbody = parsed.querySelector('.drawer__cart-items-wrapper tbody');

    if (!newTbody) {
      syncDrawerEmptyState(cartDrawer, parsed);
      return;
    }

    syncDrawerFilledState(cartDrawer, parsed);

    var cabRow = cartDrawer.querySelector('.vex-drawer-cab-row');
    var tbody = cartDrawer.querySelector('.drawer__cart-items-wrapper tbody');

    if (tbody) {
      tbody.querySelectorAll('.cart-item').forEach(function (row) {
        row.remove();
      });

      var insertBefore = cabRow || null;
      newTbody.querySelectorAll('.cart-item').forEach(function (row) {
        if (insertBefore) {
          tbody.insertBefore(row, insertBefore);
        } else {
          tbody.appendChild(row);
        }
      });
      return;
    }

    var oldWrapper = cartDrawer.querySelector('.drawer__cart-items-wrapper');
    var newWrapper = parsed.querySelector('.drawer__cart-items-wrapper');

    if (oldWrapper && newWrapper) {
      if (cabRow) {
        cabRow.remove();
      }

      oldWrapper.innerHTML = newWrapper.innerHTML;
      tbody = cartDrawer.querySelector('.drawer__cart-items-wrapper tbody');

      if (cabRow && tbody) {
        tbody.appendChild(cabRow);
      }
    }
  }

  function refreshDrawerFromSections(sections) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionHtml = getDrawerSectionHtml(sections);

    if (!cartDrawer || !sectionHtml) {
      return;
    }

    syncDrawerCartItems(sections);

    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');

    var footerTarget = cartDrawer.querySelector('.vex-drawer__footer');
    var newFooter = parsed.querySelector('.vex-drawer__footer');

    if (footerTarget && newFooter) {
      footerTarget.innerHTML = newFooter.innerHTML;
    }

    var itemsEl = cartDrawer.querySelector('cart-drawer-items');
    if (itemsEl) {
      itemsEl.classList.remove('is-empty');
    }

    cartDrawer.classList.remove('is-empty');

    if (sections['cart-icon-bubble']) {
      var bubbleTarget = document.getElementById('cart-icon-bubble');
      var bubbleParsed = new DOMParser().parseFromString(
        sections['cart-icon-bubble'],
        'text/html'
      );
      var bubbleSource = bubbleParsed.querySelector('.shopify-section');

      if (bubbleTarget && bubbleSource) {
        bubbleTarget.innerHTML = bubbleSource.innerHTML;
      }
    }

    scheduleDrawerProgressLayout();
  }

  function removeDrawerCabProductSlide(productId) {
    var root = document.querySelector('cart-drawer [data-vex-drawer-cab]');

    if (!root || !productId) {
      return;
    }

    root.querySelectorAll('.vex-drawer-cab-card').forEach(function (card) {
      if (String(card.dataset.productId) === String(productId)) {
        var slide = card.closest('.splide__slide');

        if (slide) {
          slide.remove();
        }
      }
    });

    var cabRow = root.closest('.vex-drawer-cab-row');

    if (root.querySelector('.splide__slide')) {
      root.hidden = false;
      root.removeAttribute('hidden');

      if (cabRow) {
        cabRow.hidden = false;
        cabRow.removeAttribute('hidden');
      }

      bindDrawerCabCardEvents(root);
    }
  }

  function addDrawerCabToCart(variantId, button) {
    if (button.classList.contains('loading') || button.getAttribute('aria-disabled') === 'true') {
      return;
    }

    var cartDrawer = document.querySelector('cart-drawer');
    var addedCard = button.closest('.vex-drawer-cab-card');
    var addedProductId = addedCard ? addedCard.dataset.productId : null;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cartDrawer) {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }

    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          return;
        }

        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          refreshDrawerFromSections(response.sections || {});
          removeDrawerCabProductSlide(addedProductId);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'vex-drawer-cab',
            cartData: response,
          });
        }
      })
      .catch(function () {
        /* ignore */
      })
      .finally(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  }

  function initDrawerSplide(sliderEl, listEl, slidesHtml, root) {
    if (!sliderEl || !listEl) {
      return null;
    }

    destroySplide(sliderEl);
    listEl.innerHTML = slidesHtml;

    var controls = root.querySelector('[data-vex-drawer-cab-controls]');
    var prevBtn = root.querySelector('[data-vex-drawer-cab-prev]');
    var nextBtn = root.querySelector('[data-vex-drawer-cab-next]');

    if (typeof Splide === 'undefined') {
      return null;
    }

    var splide = new Splide(sliderEl, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '12px',
      arrows: false,
      pagination: false,
      autoHeight: true,
    });

    function updateControls() {
      if (!prevBtn || !nextBtn) {
        return;
      }

      var index = splide.index;
      var total = splide.length;

      prevBtn.disabled = index === 0;
      nextBtn.disabled = index >= total - 1;

      if (controls) {
        controls.hidden = total <= 1;
      }
    }

    splide.on('mounted', updateControls);
    splide.on('moved', updateControls);
    splide.on('updated', updateControls);

    if (prevBtn) {
      prevBtn.onclick = function () {
        splide.go('<');
      };
    }

    if (nextBtn) {
      nextBtn.onclick = function () {
        splide.go('>');
      };
    }

    splide.mount();
    splideInstances.set(sliderEl, splide);
    updateControls();

    return splide;
  }

  function applyDrawerCabSlides(root, cardHtmlList) {
    var sliderEl = root.querySelector('[data-vex-drawer-cab-slider]');
    var listEl = sliderEl ? sliderEl.querySelector('.splide__list') : null;
    var cabRow = root.closest('.vex-drawer-cab-row');

    if (!cardHtmlList.length) {
      root.hidden = true;
      if (cabRow) {
        cabRow.hidden = true;
      }
      if (sliderEl) {
        destroySplide(sliderEl);
      }
      return;
    }

    root.hidden = false;
    root.removeAttribute('hidden');
    if (cabRow) {
      cabRow.hidden = false;
      cabRow.removeAttribute('hidden');
    }

    var slidesHtml = cardHtmlList
      .map(function (cardHtml) {
        return '<div class="splide__slide">' + cardHtml + '</div>';
      })
      .join('');

    initDrawerSplide(sliderEl, listEl, slidesHtml, root);
    bindDrawerCabCardEvents(root);
  }

  function buildDrawerCabCardsFromHandles(handles, excludeProductIds) {
    var uniqueHandles = handles.filter(function (handle, index) {
      return handle && handles.indexOf(handle) === index;
    });

    return Promise.all(uniqueHandles.map(fetchDrawerProductByHandle)).then(function (products) {
      return products
        .filter(function (product) {
          if (!product) {
            return false;
          }

          return excludeProductIds.indexOf(String(product.id)) === -1;
        })
        .map(buildDrawerCabCardHtml)
        .filter(Boolean);
    });
  }

  function injectDrawerCabRow() {
    var drawer = document.querySelector('cart-drawer');

    if (!drawer || drawer.classList.contains('is-empty')) {
      return null;
    }

    var firstItem = drawer.querySelector('.drawer__cart-items-wrapper tbody .cart-item');
    var tbody = firstItem ? firstItem.parentElement : null;

    if (!firstItem || !tbody) {
      return null;
    }

    var existing = drawer.querySelector('[data-vex-drawer-cab]');
    if (existing) {
      var existingCabRow = existing.closest('.vex-drawer-cab-row');
      if (existingCabRow && existingCabRow !== tbody.lastElementChild) {
        tbody.appendChild(existingCabRow);
      }

      var nextProductId = firstItem.dataset.productId;

      if (nextProductId && existing.dataset.productId !== nextProductId) {
        existing.dataset.productId = nextProductId;
        delete existing.dataset.vexDrawerCabInit;
      }

      return existing;
    }

    var productId = firstItem.dataset.productId;
    var heading = drawer.dataset.cabHeading || 'Customers also bought:';
    var limit = drawer.dataset.cabLimit || '8';
    var row = document.createElement('tr');
    row.className = 'vex-drawer-cab-row';
    row.setAttribute('role', 'row');
    row.hidden = true;
    row.innerHTML =
      '<td colspan="3" class="vex-drawer-cab-cell" role="cell">' +
      '<div class="vex-drawer-cab" data-vex-drawer-cab data-cab-section-id="customers-also-bought"' +
      ' data-sections-url="' +
      (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') +
      '"' +
      ' data-recommendations-url="' +
      (window.routes && window.routes.product_recommendations_url
        ? window.routes.product_recommendations_url
        : '/recommendations/products') +
      '"' +
      ' data-limit="' +
      limit +
      '"' +
      (productId ? ' data-product-id="' + productId + '"' : '') +
      ' hidden>' +
      (heading
        ? '<div class="vex-drawer-cab__heading-row">' +
          '<p class="vex-drawer-cab__heading">' +
          heading +
          '</p>' +
          '<div class="vex-drawer-cab__controls" data-vex-drawer-cab-controls hidden>' +
          '<button type="button" class="vex-drawer-cab__arrow vex-drawer-cab__arrow--prev" data-vex-drawer-cab-prev aria-label="Previous recommendation">' +
          '<span class="vex-drawer-cab__arrow-icon vex-drawer-cab__arrow-icon--prev"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></span>' +
          '</button>' +
          '<button type="button" class="vex-drawer-cab__arrow vex-drawer-cab__arrow--next" data-vex-drawer-cab-next aria-label="Next recommendation">' +
          '<span class="vex-drawer-cab__arrow-icon"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></span>' +
          '</button>' +
          '</div>' +
          '</div>'
        : '') +
      '<div class="vex-drawer-cab__body">' +
      '<div class="vex-drawer-cab__slider splide" data-vex-drawer-cab-slider>' +
      '<div class="splide__track"><div class="splide__list"></div></div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</td>';

    tbody.appendChild(row);
    return row.querySelector('[data-vex-drawer-cab]');
  }

  function initVexDrawerCab() {
    injectDrawerCabRow();
    var roots = document.querySelectorAll('[data-vex-drawer-cab]');

    roots.forEach(function (root) {
      var productId = root.dataset.productId;
      var sliderEl = root.querySelector('[data-vex-drawer-cab-slider]');

      if (!productId || document.querySelector('cart-drawer.is-empty')) {
        root.hidden = true;
        var cabRow = root.closest('.vex-drawer-cab-row');
        if (cabRow) {
          cabRow.hidden = true;
        }
        if (sliderEl) {
          destroySplide(sliderEl);
        }
        return;
      }

      if (root.dataset.vexDrawerCabInit === 'true' && root.querySelector('.splide__slide')) {
        var cabRowEl = root.closest('.vex-drawer-cab-row');
        root.hidden = false;
        root.removeAttribute('hidden');
        if (cabRowEl) {
          cabRowEl.hidden = false;
          cabRowEl.removeAttribute('hidden');
        }
        bindDrawerCabCardEvents(root);
        return;
      }

      var excludeIds = getDrawerCartProductIds();

      function renderFromCardHtmlList(cardHtmlList) {
        var handles = cardHtmlList
          .map(getHandleFromCardHtml)
          .filter(Boolean);

        buildDrawerCabCardsFromHandles(handles, excludeIds).then(function (cards) {
          root._vexDrawerCabCards = cards;
          applyDrawerCabSlides(root, cards);
          root.dataset.vexDrawerCabInit = 'true';
        });
      }

      fetchDrawerCabFallbackCards().then(function (fallbackCards) {
        if (fallbackCards.length) {
          renderFromCardHtmlList(fallbackCards);
        }

        resolveDrawerCabSectionId().then(function (sectionId) {
          fetchDrawerRecommendationCards(root, sectionId).then(function (cards) {
            if (!cards.length) {
              cards = fallbackCards;
            }

            if (cards.length) {
              renderFromCardHtmlList(cards);
            } else if (!fallbackCards.length) {
              root.hidden = true;
              var emptyCabRow = root.closest('.vex-drawer-cab-row');
              if (emptyCabRow) {
                emptyCabRow.hidden = true;
              }
            }
          });
        });
      });
    });
  }

  function getDrawerProgressSelectors() {
    return [
      '[class*="free_shipping_card_wrapper"]',
      '[class*="free_shipping"]',
      '[id^="ss-fsbar-"]:not(template)',
      '[class*="ss-fsbar-section"]',
      '.ss-free-shipping-bar',
      '[class*="free-shipping"]',
      '[class*="shipping-bar"]',
      '[class*="shipping-progress"]',
      '[class*="efs-"]',
      '[data-essential-shipping]',
    ];
  }

  function getMovableDrawerProgressRoot(node, drawer, progressSlot) {
    if (!node || !drawer || progressSlot.contains(node)) {
      return null;
    }

    var best = node;

    if (
      node.matches(
        '[class*="free_shipping_card_wrapper"], [id^="ss-fsbar-"], [class*="ss-fsbar-section"], .ss-free-shipping-bar, [class*="efs-"]'
      )
    ) {
      best = node;
    }

    var current = node.parentElement;

    while (current && current !== drawer) {
      if (
        current.matches(
          '[class*="free_shipping_card_wrapper"], [id^="ss-fsbar-"], [class*="ss-fsbar-section"], .shopify-section.ss-free-shipping-bar, [class*="efs-"]'
        )
      ) {
        best = current;
      }

      current = current.parentElement;
    }

    return best;
  }

  function shouldSkipProgressMove(node, progressSlot) {
    if (!node || node.tagName === 'TEMPLATE' || progressSlot.contains(node)) {
      return true;
    }

    if (node.closest('.vex-drawer-cab') || node.closest('.drawer__cart-items-wrapper')) {
      return true;
    }

    return false;
  }

  function moveNodeToProgressSlot(node, progressSlot) {
    if (!node || !progressSlot || progressSlot.contains(node)) {
      return;
    }

    progressSlot.insertBefore(node, progressSlot.firstChild);
  }

  function initVexDrawerLayout() {
    var progressSlot = document.querySelector('[data-vex-drawer-progress]');
    var drawer = document.querySelector('cart-drawer');

    if (!progressSlot || !drawer) {
      return;
    }

    var moved = {};
    var selectors = getDrawerProgressSelectors();

    function relocate(node) {
      if (shouldSkipProgressMove(node, progressSlot)) {
        return;
      }

      var root = getMovableDrawerProgressRoot(node, drawer, progressSlot);

      if (!root || moved[root.id || root.className]) {
        return;
      }

      moved[root.id || root.className] = true;
      moveNodeToProgressSlot(root, progressSlot);
    }

    selectors.forEach(function (selector) {
      drawer.querySelectorAll(selector).forEach(relocate);
    });

    document.querySelectorAll(selectors.join(',')).forEach(function (node) {
      if (!drawer.contains(node)) {
        return;
      }

      relocate(node);
    });

    var progressBars = progressSlot.querySelectorAll(
      '[id^="ss-fsbar-"], [class*="free_shipping_card_wrapper"], [class*="ss-fsbar-section"]'
    );

    for (var i = 1; i < progressBars.length; i++) {
      progressBars[i].remove();
    }
  }

  function scheduleDrawerProgressLayout() {
    [0, 100, 300, 600, 1200].forEach(function (delay) {
      window.setTimeout(initVexDrawerLayout, delay);
    });
  }

  function initAll(scope) {
    var context = scope || document;

    initVexCartLayout();
    initVexDrawerLayout();
    initVexDrawerCab();
    scheduleDrawerProgressLayout();

    context.querySelectorAll('.vex-cl').forEach(function (section) {
      initVexCollectionList(section);
    });

    var rvRoots = context.querySelectorAll
      ? context.querySelectorAll('[data-vex-rv]')
      : [];

    if (context.matches && context.matches('[data-vex-rv]')) {
      rvRoots = [context];
    }

    rvRoots.forEach(function (root) {
      if (root.dataset.vexRvInit === 'true') {
        refreshRecentlyViewed(root);
      } else {
        initRecentlyViewed(root);
      }
    });

    var cabRoots = context.querySelectorAll
      ? context.querySelectorAll('[data-vex-cab]')
      : [];

    if (context.matches && context.matches('[data-vex-cab]')) {
      cabRoots = [context];
    }

    cabRoots.forEach(function (root) {
      if (root.dataset.vexCabInit === 'true') {
        refreshCustomersAlsoBought(root);
      } else {
        initCustomersAlsoBought(root);
      }
    });
  }

  bindJudgeMeListeners();

  var vexDrawerLayoutObserverBound = false;
  var vexDrawerProgressObserverBound = false;

  function bindVexDrawerOpenLayout() {
    if (vexDrawerLayoutObserverBound) {
      return;
    }

    var drawer = document.querySelector('cart-drawer');

    if (!drawer || typeof MutationObserver === 'undefined') {
      return;
    }

    vexDrawerLayoutObserverBound = true;

    new MutationObserver(function () {
      if (drawer.classList.contains('active')) {
        scheduleDrawerProgressLayout();
      }
    }).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function bindVexDrawerProgressObserver() {
    if (vexDrawerProgressObserverBound) {
      return;
    }

    var drawer = document.querySelector('cart-drawer');

    if (!drawer || typeof MutationObserver === 'undefined') {
      return;
    }

    vexDrawerProgressObserverBound = true;

    new MutationObserver(function () {
      window.setTimeout(initVexDrawerLayout, 50);
    }).observe(drawer, {
      childList: true,
      subtree: true,
    });
  }

  function patchCartDrawerRenderContents() {
    var CartDrawerEl = customElements.get('cart-drawer');

    if (!CartDrawerEl || CartDrawerEl.prototype._vexRenderContentsPatched) {
      return;
    }

    var originalRenderContents = CartDrawerEl.prototype.renderContents;

    CartDrawerEl.prototype.renderContents = function (parsedState) {
      originalRenderContents.call(this, parsedState);
      initVexDrawerCab();
      scheduleDrawerProgressLayout();
    };

    CartDrawerEl.prototype._vexRenderContentsPatched = true;
  }

  bindVexDrawerOpenLayout();
  bindVexDrawerProgressObserver();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchCartDrawerRenderContents();
      initAll();
    });
  } else {
    patchCartDrawerRenderContents();
    initAll();
  }

    document.addEventListener('shopify:section:load', function (event) {
    if (document.body.classList.contains('template-cart')) {
      initVexCartLayout();
    }
    initVexDrawerLayout();
    initAll(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'vex-drawer-cab') {
        return;
      }

      window.setTimeout(function () {
        initVexDrawerLayout();

        if (event && event.source === 'product-form') {
          initVexDrawerCab();
          scheduleDrawerProgressLayout();
          return;
        }

        var cabRoot = document.querySelector(
          'cart-drawer [data-vex-drawer-cab][data-vex-drawer-cab-init="true"]'
        );

        if (cabRoot && cabRoot.querySelector('.splide__slide')) {
          var cabRow = cabRoot.closest('.vex-drawer-cab-row');

          cabRoot.hidden = false;
          cabRoot.removeAttribute('hidden');

          if (cabRow) {
            cabRow.hidden = false;
            cabRow.removeAttribute('hidden');
          }

          bindDrawerCabCardEvents(cabRoot);
        } else {
          initVexDrawerCab();
        }

        scheduleDrawerProgressLayout();
      }, 50);
    });
  }

  window.vexSyncDrawerCartItems = syncDrawerCartItems;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document
        .querySelectorAll('[data-vex-rv][data-vex-rv-init="true"]')
        .forEach(function (root) {
          refreshRecentlyViewed(root);
        });

      document
        .querySelectorAll('[data-vex-cab][data-vex-cab-init="true"]')
        .forEach(function (root) {
          refreshCustomersAlsoBought(root);
        });
    }, 200);
  });
})();
